import { render, staticRenderFns } from "./ForgotPasswordModule.vue?vue&type=template&id=678c9ed5&scoped=true&"
import script from "./ForgotPasswordModule.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordModule.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordModule.vue?vue&type=style&index=0&id=678c9ed5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c9ed5",
  null
  
)

export default component.exports